import defaultSettings from "@user-center/settings";

export function transferString(data: any): string {
  return typeof data != "string" ? (data ? String(data) : "") : data;
}

const title = defaultSettings.title || "Vue Admin Template";

export function getPageTitle(pageTitle: string, localTitle: any): string {
  if (pageTitle) {
    return `${pageTitle} - ${localTitle || title}`;
  }
  return `${title}`;
}
